import {Button, Checkbox, Container, Input, Message, Modal, Popup} from "semantic-ui-react";
import React, {Component} from 'react'
import {JoinSessionModal} from "./join_session_modal.jsx";
import {SessionInformation} from "../utils_components.jsx";
import {ClipboardText} from "./clipboard.jsx";
import {DawidConfirm} from "./confirm.jsx";

function download(filename, text) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

Date.prototype.addDays = function (days) {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

function dateToString(date) {
    const month = date.getUTCMonth() + 1; // months from 1-12
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    return year + "-" + month + "-" + day;
}

export class DawidButtonsBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageVisible: true,
            emailAddressFieldValue: props.emailAddress,
            deleteConfirmOpen: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !(this.props.expiration === nextProps.expiration &&
            this.props.emailAddress === nextProps.emailAddress &&
            this.props.mode === nextProps.mode &&
            this.props.sessionIdPrivate === nextProps.sessionIdPrivate &&
            this.props.sessionIdPublic === nextProps.sessionIdPublic &&
            this.props.sessionCreated === nextProps.sessionCreated &&
            this.props.clientConnected === nextProps.clientConnected &&
            this.state === nextState);
    }

    submitEmail() {
        this.props.submitEmail(this.state.emailAddressFieldValue);
    }

    fileInputRef = React.createRef();

    fileChanged(e) {
        const fileToUpload = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => this.onReaderLoad(event);
        reader.readAsText(fileToUpload);
    }

    onReaderLoad(event) {
        const sessionToImport = JSON.parse(event.target.result);
        this.props.importState(sessionToImport);
        this.fileInputRef.current.value = "";
    }

    deleteSessionClicked(event) {
        this.setState({deleteConfirmOpen: true});
    }

    render() {
        const {
            clientConnected,
            sessionCreated,
            exportState,
            createSession,
            joinSession,
            sessionIdPublic,
            sessionIdPrivate,
            mode,
            expiration,
            emailAddress,
            toggleLargeFont,
            deleteSession
        } = this.props;
        const {emailAddressFieldValue, deleteConfirmOpen} = this.state;
        const hasLocalStorage = localStorage.getItem('state');
        const labelConnection = clientConnected ? "connected" : "not connected";
        const privateLink = sessionIdPublic + '#' + sessionIdPrivate;
        const messageVisible = this.state.messageVisible && sessionCreated && mode === 'editor';
        const expirationDays = Math.floor(expiration / 60 / 60 / 24);
        const dateObj = new Date();
        const today = dateToString(dateObj);
        const exportFileName = 'session_' + today + ".json";

        const expirationDate = dateToString(dateObj.addDays(expirationDays));

        return (
            <React.Fragment>
                <Message hidden={!messageVisible}>
                    <Message.Header>Keep the following identifier to be able to return to your run
                        later</Message.Header>
                    <ClipboardText value={privateLink}/>
                </Message>
                {expiration && <Message hidden={!messageVisible}>
                    <Message.Header>This session will expire on {expirationDate}</Message.Header>
                    {!emailAddress &&
                    <Modal trigger={<a href={'#'}>Click here to be notified by email before it gets deleted.</a>}>
                        <Modal.Header>Notification before session deletion</Modal.Header>
                        <Modal.Content>
                            <Modal.Description>
                                <Input type={'email'} value={emailAddressFieldValue}
                                       onChange={(e, {value}) => this.setState({emailAddressFieldValue: value})}
                                       label={'Your email address'}/>
                                <Button onClick={this.submitEmail.bind(this)}
                                        style={{marginLeft: '50px'}}
                                        type={'Submit'}
                                        content={'Submit'}/>
                            </Modal.Description>
                        </Modal.Content>
                    </Modal>}
                    {emailAddress &&
                    <p>You will be notified at <span style={{color: "#ec7723"}}>{emailAddress}</span> before it gets
                        deleted.
                    </p>}
                </Message>}
                <Container textAlign='left' id="buttons_bar" style={{width: '100%'}}>
                    <input onChange={this.fileChanged.bind(this)}
                           ref={this.fileInputRef}
                           type="file"
                           hidden
                    />
                    <div style={{float: 'left'}}>

                        <Popup
                            trigger={<Button id="ws-status" positive={clientConnected} negative={!clientConnected}
                                             style={{marginBottom: '20px'}}>{labelConnection}</Button>}
                            content={'Status of the connection to Dawid\'s backend server (web socket)'}
                        />
                        {mode === 'editor' && <Popup
                            trigger={<Button
                                onClick={(e) => download(exportFileName, exportState())}
                                style={{marginBottom: '20px'}} icon="download"/>}
                            content='Export your current session'
                        />}
                        {mode === 'editor' && <Popup
                            trigger={
                                <Button
                                    icon="upload"
                                    onClick={() => this.fileInputRef.current.click()}
                                />
                            }
                            content='Import a session'
                        />
                        }
                        {
                            !sessionCreated &&
                            <Popup trigger={<Button id="create-session" onClick={(e) => createSession(e)}
                                                    style={{marginBottom: '20px'}}>Create remote session</Button>}
                                   content={'This will save your progress on our server and will allow' +
                                   ' sharing the session with observers'}/>
                        }
                        {
                            !sessionCreated &&
                            <JoinSessionModal
                                popUpText={'To resume a previous run or join someone else run as observer'}
                                onSubmit={(value) => joinSession(value)}/>
                        }
                        {
                            sessionCreated && <SessionInformation sessionIdPublic={sessionIdPublic}
                                                                  sessionIdPrivate={sessionIdPrivate}
                                                                  role={mode}/>
                        }
                        {
                            sessionCreated && mode === 'editor' &&
                            <Popup trigger={<Button id="delete-session" onClick={this.deleteSessionClicked.bind(this)}
                                                    style={{marginBottom: '20px'}}>Delete session</Button>}
                                   content={'This will delete your session from our server.'}/>
                        }
                    </div>
                    <div id="presentationModeToggle" style={{float: 'right', paddingTop: '7px', marginBottom: '30px'}}>
                        <Checkbox id={'togglePresentation'} onChange={(e) => toggleLargeFont(e)}
                                  label={'presentation mode'} toggle/>
                    </div>
                </Container>
                <br style={{clear: 'both'}}/>
                {deleteConfirmOpen && <DawidConfirm open={this.state.deleteConfirmOpen}
                                                    onConfirm={() => {
                                                        deleteSession();
                                                        this.setState({deleteConfirmOpen: false})
                                                    }}
                                                    content={"Do you really want to delete your session from our" +
                                                    " server? This is definitive and it will not be possible to recover" +
                                                    " the data associated with this session."}
                                                    cancelText={"I've changed my mind, don't delete"}
                                                    confirmText={"Delete"}
                                                    onCancel={() => this.setState({deleteConfirmOpen: false})}/>}
            </React.Fragment>
        )

    }
}